<template>
  <div>
    <div class="cs-header">
      <el-row>
        <el-col :span="8" class="cs-header-left">
          <div class="cs-logo">
            <div class="cs-logo-container">
              <img src="@/assets/logo.png">
              <!-- <img src="./assets/avantClass_logo_white_small.png"> -->
            </div>
            <i class="fa fa-bars" aria-hidden="true" v-show="isLogged" @click="menuHandler"></i>
          </div>
        </el-col>

        <el-col :span="8">
          <span v-if="!isLogged || !hasIncompleteWorkflowCount">&nbsp;</span>
          <span class="cs-incompleteWorkflowCount" v-else @click="onIncompleteClick">当前有{{incompleteWorkflowCount}}条未完成流程未处理</span>

          <span v-if="!isStudentOnlineCourseValid" class="cs-checkStudentOnlineCourseMsg cs-redLabel">请及时补看线上课程视频
            <el-popover placement="bottom" title="" width="500" trigger="click">
              <div v-html="checkStudentOnlineCourseMsg">
              </div>
              <a slot="reference">查看详情</a>
            </el-popover>
          </span>
        </el-col>
        <el-col :span="8" class="cs-header-right">
          <div class="cs-userInfo" style v-show="isLogged">
            <a>欢迎回来,</a>
            <a v-text="username"></a>
            <a style="margin-left:20px;margin-right:20px" href="javascript:void(0);" class="float-right" v-on:click="logout()">注销</a>
          </div>
        </el-col>
      </el-row>
    </div>
    <div :class="{'cs-content' : true, 'cs-content-afterLogin': isLogged }">
      <div class="cs-mobile-menu" v-if="!hideMenu">
        <navigator @selectMenu="selectMenu"></navigator>
      </div>
      <div class="cs-content-body">
        <router-view @logged-event="onLogged()" @logout="logout" />
      </div>
    </div>
    <el-row class="cs-mobile-footer backgroud-white text-center">
      <el-col>
        <footer>
          @{{currentYear}} 版权归速成教育所有
        </footer>
      </el-col>
    </el-row>
    <el-dialog title="未完成流程" :center="true" :close-on-click-modal="false" width="80%" class="cs-incompleteWorkflowList-dialog"
      v-on:close="onCloseIncompleteWorkflowList" :visible.sync="displayIncompleteWorkflowList" top="5vh">
      <incompleteWorkflowList :username="username" @view="onView" @reloadCount="onReloadCount"></incompleteWorkflowList>
    </el-dialog>
  </div>
</template>

<script>
import { getStore, compileStr, setStore, clearUserInStore, checkUserWechatPass } from "@/config/mUtils";
import navigator from "@/components/navigator";
import incompleteWorkflowList from "@/components/addCollectFees/incompleteWorkflowList";

import { getIncompleteWorkflowCount } from "@/service/enrollmentFee.service";
import { getBlobStorageConfig } from "@/service/blobStorage.service";
import { checkStudentOnlineCourse } from "@/service/course.service";

export default {
  name: "MainLayout",
  data() {
    return {
      isLogged: window.localStorage.getItem("user_name") !== null,
      username: window.localStorage.getItem("user_name"),
      hideMenu: true,
      incompleteWorkflowCount: 0,
      displayIncompleteWorkflowList: false,
      isReloadCount: false,
      hasIncompleteWorkflowCount: false,
      currentYear: 2020,
      isAdminLogin: false,
      isStudentOnlineCourseValid: true,
      checkStudentOnlineCourseMsg: "",
    };
  },
  components: {
    navigator,
    incompleteWorkflowList,
  },
  created() {
    this.currentYear = new Date().getFullYear();
    let path = this.$route.path;
    this.isAdminLogin = false;
    if (this.GLOBAL.wechatEnable && this.USERMANAGER.isStudent) {
      let isUserWechatPassed = checkUserWechatPass();
      if (!isUserWechatPassed){
        clearUserInStore();
        window.location.href = "/";
        return;
      }
    }
    if (
      path == "/" ||
      path == "/login" ||
      path == "/register" ||
      path == "/admin/" ||
      path == "/admin"
    ) {
      this.isLogged = false;
      if (path == "/admin/" || path == "/admin") {
        this.isAdminLogin = true;
      }
    } else {
      if (window.localStorage.getItem("user_name") !== null) {
        this.isLogged = true;
        this.checkHasIncompleteWorkflowCount();
        this.refreshIncompleteWorkflowCount();
      } else {
        this.isLogged = false;
      }
    }
    this.addtawk();
    this.loadCheckStudentOnlineCourse();
    if (this.isLogged && this.USERMANAGER.isStudent) {
      this.setBlobStorageConfig();
    }
  },
  methods: {
    onReloadCount() {
      this.isReloadCount = true;
    },
    checkIsReloadCount() {
      if (this.isReloadCount) {
        this.refreshIncompleteWorkflowCount();
        this.isReloadCount = false;
      }
    },
    onView(row) {
      this.checkIsReloadCount();
      this.displayIncompleteWorkflowList = false;
      let path = "";
      if (row.EnrollmentType == 1) {
        path = "/addCollectFees/advanceEnrollmentFee";
      } else {
        path = "/addCollectFees/courseEnrollmentFee";
      }
      this.$router.push({
        path: path,
        query: {
          studentId: row.StudentId,
        },
      });
    },
    onIncompleteClick() {
      this.displayIncompleteWorkflowList = true;
    },
    onCloseIncompleteWorkflowList() {
      this.displayIncompleteWorkflowList = false;
      this.checkIsReloadCount();
    },
    refreshIncompleteWorkflowCount() {
      if (!this.hasIncompleteWorkflowCount) {
        return;
      }
      getIncompleteWorkflowCount().then((result) => {
        if (!!result && result.success) {
          this.incompleteWorkflowCount = result.data;
        } else {
          //this.isLogged = false;
        }
      });
    },
    setBlobStorageConfig() {
      getBlobStorageConfig().then((result) => {
        if (!!result && result.success) {
          let configureStr = compileStr(JSON.stringify(result.data));
          setStore("blobStorageConfig", configureStr);
        }
      });
    },
    selectMenu() {
      this.hideMenu = true;
    },
    menuHandler() {
      this.hideMenu = !this.hideMenu;
    },
    checkHasIncompleteWorkflowCount() {
      this.hasIncompleteWorkflowCount =
        this.USERMANAGER.isAdmin ||
        this.USERMANAGER.isSales ||
        this.USERMANAGER.isReceptionist ||
        this.USERMANAGER.isFinancialManager ||
        this.USERMANAGER.isInternationalSales;
    },
    onLogged() {
    
      this.isLogged = window.localStorage.getItem("user_name") !== null;
      this.username = window.localStorage.getItem("user_name");
      this.setBlobStorageConfig();
      this.checkHasIncompleteWorkflowCount();
      this.refreshIncompleteWorkflowCount();
      this.loadCheckStudentOnlineCourse();
    },
    logout() {
      let isStudent = this.USERMANAGER.isStudent;
      window.localStorage.clear();
      this.isLogged = false;
      if (!isStudent) {
        window.location.href = "/admin/";
      } else {
        window.location.href = "/";
      }
    },
    addtawk() {
      if (!process.env.EnableTawk) {
        return;
      }
      if (
        (!this.isLogged || this.USERMANAGER.isStudent) &&
        !this.isAdminLogin
      ) {
        var Tawk_API = Tawk_API || {},
          Tawk_LoadStart = new Date();
        var s1 = document.createElement("script"),
          s0 = document.getElementsByTagName("script")[0];
        s1.async = true;
        s1.src = "https://embed.tawk.to/60cd2c8765b7290ac636bd66/1f8gnbsct";
        s1.charset = "UTF-8";
        s1.setAttribute("crossorigin", "*");
        s0.parentNode.insertBefore(s1, s0);
      }
    },
    loadCheckStudentOnlineCourse() {
      if (this.isLogged && this.USERMANAGER.isStudent) {
        checkStudentOnlineCourse().then((result) => {
          if (result && result.success) {
            if (result.data.Ok) {
              this.isStudentOnlineCourseValid = true;
            } else {
              this.isStudentOnlineCourseValid = false;
              this.checkStudentOnlineCourseMsg = result.data.Message;
            }
          } else {
            this.isStudentOnlineCourseValid = true;
          }
        });
      }
    },
  },
  watch: {
    username: function (v) {},
  },
  beforeRouteLeave(to, from, next) {},
};
</script>

<style lang="scss" scoped>
.cs-userInfo,
.cs-globalSettings {
  float: right;
  display: table-cell;
  height: 50px;
  line-height: 50px;
  vertical-align: middle;
  margin-left: 20px;

  a {
    color: white;
  }
}
.cs-incompleteWorkflowCount {
  line-height: 50px;
  margin-left: 100px;
  display: block;
  color: #59c2e6;
  cursor: pointer;
  // text-decoration:underline
}
.cs-checkStudentOnlineCourseMsg {
  line-height: 50px;
  a {
    margin-left: 10px;
    color: red;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/MainLayout.vue